export function courseTranslate(course) {
  switch (course) {
    case 1:
      return '数学'
    case 2:
      return '语文'
    case 3:
      return '英语'
    case 4:
      return '合订本'
    case 5:
      return '物理'
    case 6:
      return '化学'
    case 7:
      return '生物'
    case 8:
      return '政治'
    case 9:
      return '历史'
    case 10:
      return '地理'
    case 14:
      return '道德与法治'
  }
}
export function gardTranslate(course) {
  switch (course) {
    case 1:
      return '一年级'
    case 2:
      return '二年级'
    case 3:
      return '三年级'
    case 4:
      return '四年级'
    case 5:
      return '五年级'
    case 6:
      return '六年级'
    case 7:
      return '七年级'
    case 8:
      return '八年级'
    case 9:
      return '九年级'
  }
}
export function termTranslate(term) {
  switch (term) {
    case 1:
      return '上'
    case 2:
      return '下'
  }
}
